import './Button.scss';

export const Button = ({ variant, text, icon, iconPosition, onClick, isDisabled }) => {
  if (!variant) {
    variant = 'primary';
  }
  const renderIcon = () => {
    if (icon) {
      return (
        <span className={`icon ${iconPosition}`}>
          <img src={icon} />
        </span>
      );
    }
    return null;
  };

  return (
    <button className={`btn btn-${variant}`} onClick={onClick} disabled={isDisabled}>
      <div className="content">
        {iconPosition === 'prefix' && renderIcon()}
        <span>{text}</span>
        {iconPosition === 'suffix' && renderIcon()}
      </div>
    </button>
  );
};
